import { FunctionComponent, memo, useState } from 'react'
import { Skeleton } from '@material-ui/lab'

import { useAsyncEffect } from 'hooks/useAsyncEffect'
import { useMounted } from 'hooks/useMounted'

interface Props {
  src: () => Promise<{ default: string }>
  alt: string
  width?: string | number
  height: string | number
}

const LazySvg: FunctionComponent<Props> = ({
  src,
  alt,
  width = 'auto',
  height
}) => {
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null)

  const mounted = useMounted()

  useAsyncEffect(async () => {
    const srcPath = await src()
    if (mounted.current) {
      setLoadedSrc(srcPath?.default)
    }
  }, [src])

  if (!loadedSrc) {
    return <Skeleton variant="rect" height={height} />
  }

  return <img src={loadedSrc} alt={alt} width={width} height={height} />
}

export default memo(LazySvg)
